/* Forged prototype shared behaviour: mobile menu, scroll reveals, deferred videos.
   Load with <script src="assets/forged.js" defer></script>. Page-specific GSAP goes in the page. */
document.documentElement.classList.add('js');
window.addEventListener('DOMContentLoaded', function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var bg = document.querySelector('.ms-burger'), mn = document.getElementById('mnav');
  if (bg && mn) {
    bg.addEventListener('click', function () { var o = mn.classList.toggle('ms-open'); bg.setAttribute('aria-expanded', o); });
    mn.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { mn.classList.remove('ms-open'); bg.setAttribute('aria-expanded', false); }); });
  }

  // Announcement bar (<div class="ann">): rotates every 5 s, pauses on hover/focus; reduced motion shows all lines, no rotation.
  var ann = document.querySelector('.ms-ann');
  if (ann) {
    var sl = ann.querySelectorAll('.ms-ann-slide'), k = 0, held = false;
    if (reduce || sl.length < 2) ann.classList.add('ms-static');
    else {
      sl.forEach(function (s, i) { if (i) s.setAttribute('aria-hidden', 'true'); });
      ['mouseenter', 'focusin'].forEach(function (ev) { ann.addEventListener(ev, function () { held = true; }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { ann.addEventListener(ev, function () { held = false; }); });
      setInterval(function () {
        if (held || document.hidden) return;
        sl[k].classList.remove('ms-is-on'); sl[k].setAttribute('aria-hidden', 'true');
        k = (k + 1) % sl.length; sl[k].classList.add('ms-is-on'); sl[k].removeAttribute('aria-hidden');
      }, 5000);
    }
  }

  // Header search: .srch-ic toggles the #srch overlay row (prototype posts to the live store's /search).
  var si = document.querySelector('.ms-srch-ic'), sp = document.getElementById('srch');
  if (si && sp) {
    var sq = sp.querySelector('input'), sclose = function () { sp.hidden = true; si.setAttribute('aria-expanded', 'false'); };
    si.addEventListener('click', function () { var o = sp.hidden; sp.hidden = !o; si.setAttribute('aria-expanded', String(o)); if (o) sq.focus(); });
    sp.querySelector('.ms-srch-x').addEventListener('click', function () { sclose(); si.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sp.hidden) { sclose(); si.focus(); } });
  }

  // <video data-src="..."> loads after first paint so the poster stays the LCP element
  document.querySelectorAll('video[data-src]').forEach(function (v) {
    if (reduce) return;
    setTimeout(function () {
      v.src = v.dataset.src;
      v.addEventListener('canplay', function () { v.classList.add('ms-ready'); v.play().catch(function () {}); }, { once: true });
    }, 1200);
  });

  // Animated beams: <div class="beams"> with [data-node="x"] cards and <i data-beam="x>y" data-offset="px"> links.
  // Lines run centre to centre behind the cards; data-offset shifts a line sideways so two can share a route.
  document.querySelectorAll('.ms-beams').forEach(function (box) {
    var NS = 'http://www.w3.org/2000/svg', links = box.querySelectorAll('[data-beam]');
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'ms-beams-svg'); svg.setAttribute('aria-hidden', 'true');
    box.insertBefore(svg, box.firstChild);
    function mid(el, r) { var e = el.getBoundingClientRect(); return [e.left - r.left + e.width / 2, e.top - r.top + e.height / 2]; }
    function draw() {
      var r = box.getBoundingClientRect();
      svg.setAttribute('viewBox', '0 0 ' + r.width + ' ' + r.height);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      links.forEach(function (l, k) {
        var ends = l.dataset.beam.split('>');
        var a = box.querySelector('[data-node="' + ends[0] + '"]'), b = box.querySelector('[data-node="' + ends[1] + '"]');
        if (!a || !b) return;
        var p = mid(a, r), q = mid(b, r), dx = q[0] - p[0], dy = q[1] - p[1], n = Math.hypot(dx, dy) || 1, o = +l.dataset.offset || 0;
        var ox = -dy / n * o, oy = dx / n * o, d = 'M' + (p[0] + ox) + ',' + (p[1] + oy) + 'L' + (q[0] + ox) + ',' + (q[1] + oy);
        ['ms-beam-base', 'ms-beam-flow'].forEach(function (c) {
          var path = document.createElementNS(NS, 'path');
          path.setAttribute('d', d); path.setAttribute('class', c); path.setAttribute('pathLength', '100');
          if (c === 'ms-beam-flow') path.style.animationDelay = (k * .55) + 's';
          svg.appendChild(path);
        });
      });
    }
    draw();
    if ('ResizeObserver' in window) new ResizeObserver(draw).observe(box); else addEventListener('resize', draw);
  });

  // Giveaway capture (<aside class="capture">): once per visitor, after 40% scroll, exit intent or 45 s; never on the cart.
  // Dismiss or entry is remembered for 14 days. Prototype only: the form records nothing.
  var cap = document.querySelector('.ms-capture');
  if (cap && !/cart\.html$/.test(location.pathname)) {
    var KEY = 'ms-capture', seen = null;
    try { seen = localStorage.getItem(KEY); } catch (e) {}
    if (!seen || Date.now() - (+seen) > 14 * 864e5) {
      var shown = false;
      var show = function () { if (shown) return; shown = true; cap.classList.add('ms-show'); };
      var stamp = function () { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
      addEventListener('scroll', function () { if (scrollY > (document.documentElement.scrollHeight - innerHeight) * 0.4) show(); }, { passive: true });
      document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) show(); });
      setTimeout(show, 45000);
      cap.querySelector('.ms-x').addEventListener('click', function () { cap.classList.remove('ms-show'); stamp(); });
      var f = cap.querySelector('form');
      if (f) f.addEventListener('submit', function (e) {
        e.preventDefault(); stamp();
        cap.querySelector('.ms-cap-body').innerHTML = '<h3>You&rsquo;re in.</h3><p>Watch for a text to confirm your entry. In the meantime, the set most people start with:</p><a class="btn btn--primary" href="pdp-v-prime.html">See the V Prime Set</a>';
      });
    }
  }

  var els = document.querySelectorAll('.ms-rv');
  if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('ms-in'); }); return; }
  els.forEach(function (el) { var i = [].indexOf.call(el.parentNode.children, el); el.style.transitionDelay = (Math.min(i, 5) * 70) + 'ms'; });
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ms-in'); io.unobserve(e.target); } });
  }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
});
